import { Component, Inject, ViewChild } from '@angular/core';
import { ImageCropperComponent, CropperSettings } from 'ngx-img-cropper';
import Swal from 'sweetalert2';
import { AsapUploadService } from '../asap-upload.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Global } from 'asap-crud';
import { AngularFireStorageReference } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-modal-upload-plugin',
    templateUrl: './modal-upload.component.html',
    styleUrls: ['./modal-upload.component.scss'],
    providers: [ AsapUploadService ]
})

export class ModalUploadPluginComponent {

    @BlockUI('blockui') blockUI: NgBlockUI;

    typeImage = false;
    uploadMode = true;
    fileName: any;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropperReady = false;
    percentage = 0;
    archive: any;
    resizeToWidth: number;
    aspectRatio: string;
    horizontal: boolean;
    format: string;
    onlyType: string;
    maintainAspectRatio = true;
    public extension: string;


    @ViewChild('cropper',{static: false}) cropper: ImageCropperComponent;
    cropperSettings: CropperSettings;
    cropperData: any;

    public storage: ('firebase' | 'cloudinary') = 'cloudinary';

    constructor(
        public global: Global,
        public service: AsapUploadService,
        public dialogRef: MatDialogRef<ModalUploadPluginComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
    ) {
        this.typeImage = (data.type === 'image') ? true : false;
        this.resizeToWidth = data.resizeToWidth;
        this.aspectRatio = data.aspectRatio;
        this.horizontal = data.horizontal;
        this.onlyType = data.onlyType;

        this.cropperSettings = new CropperSettings();
        this.cropperSettings.noFileInput = true;
        this.cropperSettings.keepAspect = false;
        this.cropperSettings.preserveSize = true;
        this.cropperSettings.dynamicSizing = true;
        this.cropperData = {};
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    storeRef(): AngularFireStorageReference {
        return this.global.getSessionData('firebase-storage');
    };

    reset() {
        this.croppedImage = '';
        this.fileName = '';
        this.imageChangedEvent = '';
        this.cropperReady = false;
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCroppedBase64(image: string) {
        this.croppedImage = image;
    }

    imageLoaded() {
        this.cropperReady = true;
    }

    imageLoadFailed() {
        console.log('Load failed');
    }

    UploadImage(event) {
        if (event.srcElement.files[0]) {
            this.imageChangedEvent = event;
            this.format = event.srcElement.files[0].type;
            this.extension = this.getFileExtension(event.srcElement.files[0].name);
            this.fileName = `${this.uid()}.${this.extension}`;

            var myReader: FileReader = new FileReader();
            myReader.onloadend = (loadEvent: any) => {
                let image = new Image();
                image.src = loadEvent.target.result;
                this.cropper.setImage(image);
                this.cropperReady = true;
                this.croppedImage = true;

            };
            myReader.readAsDataURL(event.srcElement.files[0]);
        }
    }

    dataURItoBlob(dataURI) {
        const type = 'image/png'
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        const bb = new Blob([ab], { type: type });
        return bb;
    }

    sendImage() {
        // const imagee = this.dataURItoBlob(this.croppedImage);
        const imagee = this.dataURItoBlob(this.cropperData.image);
        if (this.storage == 'firebase') {
            const caminho = this.storeRef().child('images/' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10) + this.fileName);
            const tarefa = caminho.put(imagee);
            tarefa.percentageChanges().subscribe((percentage) => {
                this.percentage = Math.round(percentage);
            });
            tarefa.snapshotChanges().pipe(
                finalize(() => {
                    caminho.getDownloadURL().subscribe((file) => {
                        this.dialogRef.close({
                            path: file,
                            name: this.fileName,
                            size: 0,
                            format: this.format
                        });                    
                    });
                })
             )
            .subscribe();
        }
        else {
            this.blockUI.start('Enviando arquivos...');
            const formData: FormData = new FormData();
            formData.append('file', imagee);
            this.service.upload(formData).subscribe((response: any) => {
                console.log("[uploadToCloudinary] response", response);
                if (response.loaded && response.total) {
                    this.percentage = Math.trunc(100 * response.loaded / response.total);
                }
                else if (response.body) {
                    this.dialogRef.close({
                        path: response.body.file.secure_url,
                        name: this.fileName,
                        size: response.body.file.bytes,
                        format: this.format,
                        aspect: response.body.file.width / response.body.file.height
                    });
                    this.blockUI.stop();
                }
            });
        }
    }

    UploadArchive(event) {
        console.log(event)
        if (event && this.whiteListUploads(event.target.files[0].type)) {
            this.fileName = event.srcElement.files[0].name;
            this.archive = event.srcElement.files[0];
            this.format = event.srcElement.files[0].type;
        } else {
            Swal.fire({
                type: 'error',
                title: 'Erro ao carregar o arquivo.',
                text: 'Verifique se o arquivo tem o formato permitido.',
                buttonsStyling: true,
                confirmButtonClass: 'btn btn-success'
            });
        }
    }

    sendArchive() {
        /** Para envio de arquivos o Cloudinary deu erro **/
        this.sendToFirebase();
    }

    sendToFirebase() {
        const name = 'archives/' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10) + '_' + this.fileName;
        this.extension = this.getFileExtension(this.fileName);
        const caminho = this.storeRef().child(`files/${this.uid()}.${this.extension}`);
        const tarefa = caminho.put(this.archive);
        tarefa.percentageChanges().subscribe((percentage) => {
            this.percentage = Math.round(percentage);
        });
        tarefa.snapshotChanges().pipe(
            finalize(() => {
                caminho.getDownloadURL().subscribe((file) => {
                    this.dialogRef.close({
                        path: file,
                        name: this.fileName,
                        format: this.format
                    });                    
                });
            })
         )
        .subscribe();
    }

    private whiteListUploads(fileType: any): boolean {
        switch (fileType) {
            case 'image/png':
                return true;
            case 'image/jpeg':
                return true;
            case 'image/jpg':
                return true;
            case 'image/gif':
                return true;
            case 'image/png':
                return true;
            case 'application/msword':
                return true;
            case 'application/pdf':
                return true;
            case 'application/zip':
                return true;
            case 'application/vnd.ms-excel':
                return true;
            case 'video/x-flv':
                return true;
            case 'video/mp4':
                return true;
            case 'application/x-mpegURL':
                return true;
            case 'video/MP2T':
                return true;
            case 'video/3gpp':
                return true;
            case 'video/quicktime':
                return true;
            case 'video/x-msvideo':
                return true;
            case 'video/x-ms-wmv':
                return true;
            case '':
                return true;
            default:
                return true;
        }
    }

    uid() {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
            this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    getFileExtension(filename) {
        return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
    }


    cropperSettingsChanged(field, value) {
        this.cropper
        this.cropperSettings[field] = value;
        this.cropperSettings = JSON.parse(JSON.stringify(this.cropperSettings));
    }
}

